/* eslint-disable i18next/no-literal-string */
import { useDebouncedValue } from "@tanstack/react-pacer";
import { useState, useSyncExternalStore } from "react";
import DetailItem from "@/features/diagnostics/components/lib/detail-item.tsx";
import { DiagnosticsEmpty } from "@/features/diagnostics/components/lib/diagnostics-card.tsx";
import { DiagnosticsList } from "@/features/diagnostics/components/lib/diagnostics.tsx";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default function ProductsList() {
    const products = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.products);

    const [query, setQuery] = useState<string>("");
    const [debouncedQuery] = useDebouncedValue(query, { wait: 250 });

    const entries = Object.entries(products);

    const normalizedQuery = debouncedQuery.trim().toLowerCase();
    const filteredEntries = normalizedQuery
        ? entries.filter(([key]) => key.toLowerCase().includes(normalizedQuery))
        : entries;

    if (entries.length === 0) {
        return <DiagnosticsEmpty>No products!</DiagnosticsEmpty>;
    }

    return (
        <>
            <input
                type="text"
                className="diagnostics-filter"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Filter products..."
            />
            {filteredEntries.length > 0 ? (
                <DiagnosticsList>
                    {filteredEntries.map(([key, value]) => (
                        <DetailItem key={key} name={key} data={value} timestamp={null} />
                    ))}
                </DiagnosticsList>
            ) : (
                <DiagnosticsEmpty>No products match your filter!</DiagnosticsEmpty>
            )}
        </>
    );
}
